import React from 'react';
import {
  IonContent,
  IonPage,
  IonSpinner,
  IonText,
} from '@ionic/react';

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Loading…' }) => (
  <IonPage>
    <IonContent className="ion-padding" fullscreen>
      <div style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
      }}
      >
        <IonSpinner name="crescent" />
        <IonText color="medium">
          <small>{message}</small>
        </IonText>
      </div>
    </IonContent>
  </IonPage>
);

export default LoadingScreen;
